var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0"},[_c('hr',{staticClass:"mt-0 mb-6"}),_c('h2',{staticClass:"text-h6 tb-text"},[_vm._v("Disclaimers")]),_c('DisclaimersAll')],1)}
var staticRenderFns = []

export { render, staticRenderFns }